<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Appraisal Matrix</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small fab @click="addNewRecord_onClick()" v-on="on">
                          <v-icon>add_circle_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Perform Appraisal</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex xs12>

                        <v-expansion-panel>
                          <v-expansion-panel-content class="accent">
                            <template v-slot:header>
                              <div style="font-size: medium;">Filter Panel</div>         
                            </template>

                            <v-container class="pt-0">
                              <v-layout row wrap>
                                <v-flex class="text-xs-right">
                                  <v-btn color="orange" small fab @click="selected_filter.push({field:'',value:''})"><v-icon color="white">add</v-icon></v-btn>
                                  <v-btn color="green" @click="generateData()">GENERATE NOW</v-btn>
                                  <v-btn color="cyan lighten-1" @click="table_setting.headers=[]; selected_filter=[]; table_setting.records=[]; table_setting.pagination.totalItems=0;">RESET FILTER</v-btn>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex>
                                  <v-card>
                                    <v-card-text v-if="selected_filter.length > 0">
                                      <v-container>
                                        <v-layout row wrap
                                          v-for="(item,i) in selected_filter"
                                          :key="i"
                                        >
                                          <v-flex xs12 md5>
                                            <v-select
                                              v-model="selected_filter[i].field"
                                              :items="get_filterable_columns"
                                              clearable
                                              item-text="text"
                                              item-value="value"
                                              label="select field"
                                            ></v-select>
                                          </v-flex>
                                          <v-flex xs12 md1 class="text-md-center">
                                            contains
                                          </v-flex>
                                          <v-flex xs12 md5>
                                            <v-text-field
                                              v-model="selected_filter[i].value"
                                              label="your text"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex xs12 md1>
                                            <v-layout justify-space-around class="mb-2">
                                              <span class="group pa-2">
                                                <v-btn color="red" small fab @click="selected_filter.splice(i,1)" :disabled="false"><v-icon color="white">clear</v-icon></v-btn>
                                                
                                              </span>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                      </v-container>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        
                        <v-data-table
                          id="appraisal_table_id"
                          ref="appraisal_table_ref"
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          :total-items="table_setting.pagination.totalItems"
                          :pagination.sync="table_setting.pagination"
                          must-sort
                          class="elevation-1"
                        >
                          <v-progress-linear color="blue" indeterminate>
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:no-data>
                            <v-alert :value="table_setting.records.length==0" color="warning" icon="warning">
                              <i>Generate filter to view records.</i>
                            </v-alert>
                          </template>
                          <template v-slot:items="props">
                                                         
                            <template v-for="(i,k) in table_setting.headers">
                              <td v-if="k==0" :key="k">
                                <v-tooltip right>
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on">{{ props.item[i["value"]] }}</span>
                                  </template>
                                  <span>{{ props.item.full_name }}</span>
                                </v-tooltip>
                              </td>
                              <td v-else class="pa-1 pl-3" :key="k">
                                <span v-if='props.item[i["value"]]' style="cursor:pointer;" @click='viewMore(props.item, i)'>
                                  {{ props.item[i["value"]]["ave_score"] }}
                                </span>
                              </td>
                            </template>
                            
                          </template>
                          <template v-slot:footer>
                            <td :colspan="table_setting.headers.length" v-if="table_setting.records.length>0">
                              <i>Records of <b>{{ table_setting.headers.length - 1 }} appraisee(s)</b> by <b>{{ table_setting.pagination.totalItems }} appraiser(s)</b></i>
                            </td>
                          </template>
                        </v-data-table>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- START dialog -->
          <v-dialog v-model="dialog.visible" persistent scrollable max-width="1000px">
            <v-card>
              <v-card-title class="headline pb-0">{{ dialog.title }} Appraisal Record ({{ dialog.appraisee }} by {{ dialog.appraiser }}) - {{ dialog.rec_id }}</v-card-title>

              <v-card-text>
                <v-container grid-list-md class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <iframe
                        id="frm_window"
                        frameborder="0"
                        :src="dialog.iframe_url"
                        width="100%"
                        :height="dialog.height"
                      ></iframe>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange" flat @click="dialog.visible = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END dialog -->

        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>

</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";

export default {
  name: "AppraisalMatrixPage",
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      // expand: false,
      username: "",
      new_filter: {
        condition: "and",
        rules: []
      },
      showMenu: false,
      filters_setting: {
        filter_row: 0,
      },
      my_filter: {
        field: "",
        value: "",
      },
      selected_filter: [],
      table_setting: {
        loading: false,
        // rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [],
        headers_filter: [
          {
            text: "Year",
            value: "year",
            class: "pa-1 pl-3",
            filterable: true,
            sortable: false,
            data_type: String
          },
          {
            text: "Qtr",
            class: "pa-1",
            value: "qtr",
            filterable: true,
            sortable: false,
            data_type: String
          },
          {
            text: "Appraisee",
            class: "pa-1",
            value: "appraisee",
            filterable: true,
            data_type: String
          },
          {
            text: "Appraiser",
            class: "pa-1",
            value: "appraiser",
            filterable: true,
            data_type: String
          },
          {
            text: "Score (%)",
            class: "pa-1",
            value: "ave_score",
            filterable: false,
            data_type: String
          },
          {
            text: "Hub",
            class: "pa-1",
            value: "hub",
            filterable: true,
            data_type: String
          },
          {
            text: "Department",
            class: "pa-1",
            value: "department",
            filterable: true,
            data_type: String
          },
          {
            text: "Type",
            align: "left",
            class: "pa-1",
            value: "type",
            filterable: true,
            data_type: String
          },
          {
            text: "Form",
            align: "left",
            class: "pa-1",
            value: "form",
            filterable: true,
            data_type: String
          },
          {
            text: "Rev",
            align: "left",
            class: "pa-1",
            value: "revision",
            filterable: false,
            data_type: Number
          },
          {
            text: "Created DateTime",
            align: "left",
            class: "pa-1",
            value: "created",
            filterable: false,
            data_type: String
          },
          {
            text: "",
            value: "a_actions",
            class: "pa-1",
            filterable: false,
            sortable: false,
            data_type: String
          }
        ],
        records: [],
        // total_items:0,
        pagination: {
          // descending: false,
          // page: 1,
          rowsPerPage: -1,
          // sortBy: "appraisee",
          totalItems: 0
        }
      },
      dialog: {
        visible: false,
        title: "",
        // appraisee: "",
        // appraiser: "",
        iframe_url: "",
        height:"",
        rec_id:""
      },
      status_option: [],
      selected: {
        id: "",
        name: "",
        parent_company_id: "",
        g_status_id: "",
        desc: ""
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers_filter.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.generateData();
      },
      deep: true
    }
  },
  async mounted() {
    // window.document.title="Talent Mgmt";
    this.username = auth.getUsername();

    var self = this;

    // this.status_option = await common.App.getGeneralOptions(
    //   "General",
    //   "status",
    //   ["id", "value"]
    // );

    function handleMessage(e) {
      if (e.data.event == "form_data_saved") {
        self.dialog.visible = false;
        self.dialog.iframe_url ="";
        self.dialog.height = e.data.window.height;
        
        //common.wMsgBox.Success("Record sucessfully updated.");
        // common.wMsgBox.Success(JSON.stringify(e));
      }
      if (e.data.event == "form_loaded") {
        self.dialog.height = e.data.window.height + 350;
      }
    }
    
    window.addEventListener("message", handleMessage, false);
    // this.refreshData();
  },
  created (){
    auth.hideHeader(false);
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },
    async generateData() {
      var filter_array = this.selected_filter;
      var no_filter = false;

      if (filter_array.length == 0) {
        no_filter = true;
        // this.table_setting.records = this.table_setting.headers = [];
        // this.table_setting.total_items=0;
      } else {
        for (var n in filter_array) {
          if (filter_array[n].field == "" || filter_array[n].value == "") {
            no_filter = true;
            // this.table_setting.records = this.table_setting.headers = [];
            // this.table_setting.total_items=0;
            break;
          }
          if (!no_filter) {
            this.refreshData();
          }
        }
      }

      if (no_filter) {
        this.table_setting.records = this.table_setting.headers = [];
        this.table_setting.pagination.totalItems=0;
      }
    },
    async refreshData() {
      // var sorting = [
      //   {sortBy: "year", descending: true},
      //   {sortBy: "qtr", descending: true},
      // ];

      // sorting.push({
      //   sortBy: this.table_setting.pagination.sortBy,
      //   descending: this.table_setting.pagination.descending 
      // });

      // var sort_el = "";
              
      // for (var m in sorting) {
      //   sort_el += " , j." + sorting[m].sortBy + (sorting[m].descending?' desc':' asc');
      // }
      // var substr_pos1 = 2;
      // var sort_el_length = sort_el.length;
      // sort_el = sort_el.substr(substr_pos1, sort_el_length - substr_pos1); // to remove , of first sorting element
      // var str1 = " sort";
      // sort_el = str1.concat(sort_el);


      var filter_el = "";
      if (this.selected_filter.length > 0) {
        var temp_filter = this.selected_filter;
        
        for (var i in temp_filter) {
          filter_el += ' && like(j.' + temp_filter[i].field + ', "%' + temp_filter[i].value + '%", true)';
        }

        var substr_pos = 3;
        var filter_el_length = filter_el.length;
        filter_el = filter_el.substr(substr_pos, filter_el_length - substr_pos); // to remove && of first filter element
        var str2 = " filter";
        filter_el = str2.concat(filter_el);
      }

      var q_return = [
        '{"year":rec.submission.data.year.name' ,
        ' "qtr":rec.submission.data.quater.name' ,
        ' "appraisee":rec.submission.data.appraisee' ,
        ' "appraiseeUsername":rec.submission.data.appraiseeUsername' , 
        ' "appraiser":rec.submission.data.appraiser' ,
        ' "appraiserUsername":rec.submission.data.appraiserUsername' ,
        ' "hub":rec.submission.data.hub' ,
        ' "department":rec.submission.data.department' ,
        ' "form":form.name' ,
        ' "created":rec.created_datetime' ,
        ' "type":rec.submission.data.type.name' ,
        ' "data_id":rec._id' ,
        ' "form_id":rec.form_id' ,
        ' "ave_score":rec.submission.data.ave_score' ,
        ' "revision":form.revision}'];

      q_return = q_return.join();


      var q_record_base = [
        'let records_base = (for form in forms filter contains(form.name,"Form 47") for rec in form_datas filter contains(rec.form_id,form._id) return ',
        q_return,
        ') '];

      q_record_base = q_record_base.join("");


      var q_record = [
        q_record_base +
        'let records_all = (for j in records_base',
        filter_el,
        ' return j) let records = (for m in records_all return m) let Tcount = count(for k in records_all return 1) return {"totalItems":Tcount, "records":records}'];

      q_record = q_record.join("");
      

      var results = await comm.getFormData(q_record);
      var results_rec = results.data[0].records;
      var results_length = results_rec.length;
      
      var header = {};
      for (i in results_rec) {
        header[results_rec[i]["appraiseeUsername"]] = {}
      }
      
      header = Object.keys(header);
      this.table_setting.headers =[{
        "text":"Appraiser/Appraisee",
        "value":"appraiser"
      }];
      
      for (i in header) {
        this.table_setting.headers.push({
          "text": header[i],
          "value": header[i]
        });
      }
      
      var actual_data = {};
      
      for (i = 0, results_length; i < results_length; i++) {
        actual_data[results_rec[i].appraiserUsername] = {};
      }
      
      var appraisers = Object.keys(actual_data);
      
      for (var i_appraiser in appraisers) {
        // console.log("dd", i_appraiser);
        for (var rec in results_rec) {
          // console.log(results_rec[rec].appraiseeUsername);

          if (appraisers[i_appraiser] == results_rec[rec].appraiserUsername) {
            actual_data[appraisers[i_appraiser]][results_rec[rec].appraiseeUsername] = {
              'ave_score': results_rec[rec].ave_score,
              'form_id': results_rec[rec].form_id,
              'data_id': results_rec[rec].data_id,
              'full_name_appraisee': results_rec[rec].appraisee
            };
            actual_data[appraisers[i_appraiser]]['full_name'] = results_rec[rec].appraiser;

            // console.table("after",actual_data);
          // } else {
            // actual_data[appraisers[i_appraiser]][results_rec[rec].appraiseeUsername] = "NIL";
          }
        }
      }
      //console.log("actual_data",actual_data);
      this.table_setting.records =[];
      for (var k in actual_data){        
        this.table_setting.records.push({
            "appraiser":k,
            ...actual_data[k]
        })
      }
      // console.table("records", this.table_setting.records);
      this.table_setting.pagination.totalItems = this.table_setting.records.length;
      
      // to assign back 2 lines below
      // this.table_setting.records = results.data[0].records;
      // this.table_setting.pagination.totalItems = results.data[0].totalItems;
      

    },
    editRecord_onClick(item) {
      this.dialog.visible = true;
      this.dialog.title = "Modify";
      this.dialog.appraisee = item.appraisee;
      this.dialog.appraiser = item.appraiser;
      this.dialog.iframe_url =
        comm.form_ip +
        // "http://192.168.22.227:5651/form?form_id=" +
        item.form_id +
        "&form_data_id=" +
        item.data_id;
    },
    viewMore(item, i) {
      this.dialog.visible = true;
      this.dialog.title = "View Appraisal Records";
      this.dialog.appraisee = item[i["value"]].full_name_appraisee;
      this.dialog.appraiser = item.full_name;
      this.dialog.rec_id = item[i["value"]].data_id;
      this.dialog.iframe_url =
        comm.form_ip +
        // "http://192.168.22.227:5651/form?form_id=" +
        item[i["value"]].form_id +
        "&form_data_id=" +
        item[i["value"]].data_id +
        "&readOnly=true";
    },
    addNewRecord_onClick() {
      this.$router.push({ path: "/appraisal_form" });
    },
    viewMenu() {
      this.showMenu = true;
    },
    // main_menu_onClick(action_name) {
    //   this.$router.push({ name: action_name });
    // },

    save_onClick() {
      // let self = this;

      // this.$validator.validateAll().then(async result => {
      //   if (result) {
      //     let result = await common.wBackEndComm.PostData(
      //       "company/crud_company/",
      //       self.selected
      //     );

      //     if (result.data.Status == 1) {
      //       self.dialog.visible = false;
      //       self.refreshData();
      //       common.wMsgBox.Success(result.data.Description);
      //     } else {
      //       common.wMsgBox.Error(result.data.Description);
      //     }
      //   }
      // });
    }
  }
};
</script>

<style scope>
  /* .v-datatable__actions{
    visibility: hidden;
  } */
</style>
